import type { FlexProps} from '@chakra-ui/react'
import { Flex, FormLabel, Switch } from '@chakra-ui/react'
import { organizationListContext } from 'brokertslib/src/context'
import { useContext } from 'react'

import { SearchField } from '@/components'

interface OrganizationListFilterProps extends FlexProps {
  disableShowRootOnly?: boolean
}

export const OrganizationListFilter = ({
  disableShowRootOnly,
  ...rest
}: OrganizationListFilterProps) => {
  const { filter, updateFilter } = useContext(
    organizationListContext,
  )

  return (
    <Flex gap={4} {...rest}>
      <SearchField
        onSearch={(search) => updateFilter({ ...filter, name: search })}
      />

      <Flex justifyContent="right" gap={4} w="full" alignItems={'center'}>
        <Switch
          size="md"
          id="showInactive"
          isChecked={filter.showInvalid}
          onChange={() => {
            updateFilter({ ...filter, showInvalid: !filter.showInvalid, pageIndex: 1 })
          }}
        />
        <FormLabel htmlFor="showInactive" variant="switch">
          Zobrazit i neaktivní
        </FormLabel>

        {!disableShowRootOnly && (
          <>
            <Switch
              size="md"
              id="showRootOnly"
              isChecked={filter.showRootOnly}
              onChange={() => {
                updateFilter({ ...filter, showRootOnly: !filter.showRootOnly, pageIndex: 1 })
              }}
            />
            <FormLabel htmlFor="showRootOnly" variant="switch">
              Pouze root organizace
            </FormLabel>
          </>
        )}
      </Flex>
    </Flex>
  )
}
